export default {
	articleEditDialog: {
		title: "Artikel {articleId} - Einstellungen",
		articleNameLabel: "Artikelname",
		articleNumberLabel: "Artikelnummer",
		articleNumberPlaceholder: "Ihre Artikelnummer",
		articleNumberHint:
			"Sie können jedem Artikel eine eigene Artikelnummer vergeben. Die Nummer erscheint auch auf dem Lieferschein und der Rechnung.",
		materialLabel: "Material",
		deburringLabel: "Entgraten:",
		migratedHint: "Blexonisieren Sie den Artikel, um die Entgratung zu verändern.",
		deburringPlaceholder: "Bitte Entgratart wählen...",
		werkstoffChangedHint:
			"Wenn das Material geändert werden soll, muss der Artikel zuerst neu berechnet werden, bevor die Entgratart angepasst werden kann. Speichern Sie dazu die aktuellen Änderungen und warten Sie, bis der Artikel validiert ist.",
		deburringInfoTooltip: "Informationen über das Entgraten von Metallteilen",
		close: "Schliessen",
		saveMaterialTooltip: "Speichert das Material.",
		saveArticleTooltip: "Speichert den Artikel mit den angegebenen Daten.",
		saveFailedError: "Die Daten konnten nicht gespeichert werden. {error}",
		saveMaterialFailedError: "Das Material konnte nicht geändert werden. {error}",
	},
	articleDeleteWarningDialog: {
		title: "Achtung!",
		inCartsText: "Der Artikel wird ebenfalls aus folgenden Stücklisten gelöscht:",
		confirmDelete: "Möchten Sie den Artikel wirklich löschen?",
		weldedText:
			"Dieser Artikel kann nicht gelöscht werden, da er mit anderen Artikeln dieser Baugruppe verschweißt ist.",
		delete: "Löschen",
		messages: {
			deleteError: "Artikel konnte nicht gelöscht werden.",
		},
	},
	articleMultiDeleteDialog: {
		title: "Mehrere Artikel löschen",
		deletedProgress: "{deleted} von {total} gelöscht",
		lockedArticlesText:
			"Folgende Artikel sind entweder gesperrt oder werden derzeit berechnet und können deshalb {not} gelöscht werden:",
		lockedArticlesTextBold: "nicht",
		partOfCartsText: "Folgende Artikel sind Teil mindestens einer Stückliste:",
		containedIn: "Enthalten in...",
		confirmDeleteCount: "Möchten Sie {count} Artikel wirklich löschen?",
		noneCanBeDeleted: "Keiner der ausgewählten Artikel kann gelöscht werden.",
		delete: "Löschen",
		messages: {
			deleteError: "Fehler beim Löschen eines Artikels.",
		},
	},
	articlePriceInfoDialog: {
		title: "Den finalen Preis inkl. Mengenrabatt sehen Sie im Warenkorb.",
		intro:
			"Die Preisliste dient Konstrukteuren zur schnellen Preisabschätzung und gilt für die Bestellung dieses einen Artikels (sortenrein).",
		explanation:
			"Um den finalen Preis zu kalkulieren, stellen Sie bitte einen Warenkorb zusammen und lassen Sie sich innert Sekunden ein Angebot inkl. Liefertermin berechnen.",
		discountExplanation:
			"Bei der Angebotsberechnung werden alle enthaltenen Artikel berücksichtigt und ein auftragsspezifischer Rabatt (Auftragsrabatt) berechnet.",
		discountHighlight:
			"Mehrere Artikel mit gleichen Bearbeitungen oder gleichem Material führen zu einem Preisnachlass.",
		factorsIntro: "Folgende Faktoren führen zu einer {reduction}",
		factorsReductionBold: "Preisreduktion:",
		factor1: "Mehrere Artikel aus dem gleichen Rohmaterial (gleicher Werkstoff und gleiche Blechdicke)",
		factor2:
			"Mehrere Artikel mit den gleichen Bearbeitungen (Gewinde, Senkungen und Durchzüge) in gleichem Rohmaterial",
		factor3: "Mehrere Artikel mit gleicher Pulverbeschichtung (gleiches Pulver)",
		factor4: "Mehrere Artikel mit gleicher Verzinkung",
		priceNote:
			"Der Preis versteht sich exkl. Mehrwert- bzw. Umsatzsteuer, auftragsspezifischen Rabatten, Verpackung und Lieferung.",
		close: "Schliessen",
	},
	articleTreatmentEditDialog: {
		closeTooltip: "Dialog schliessen.",
		notAvailableTitle: "Pulverbeschichtung",
		notAvailableText: "Das Pulverbeschichten von Artikeln ist in Ihrer Region leider noch nicht verfügbar.",
		titleSingle: "Pulverbeschichtung - Artikel '{name}' ({id})",
		titleMultiple: "Pulverbeschichtung - {count} Artikel",
		standardColorsHint: "Es werden nur Standardfarben ohne Aufpreis angezeigt.",
		showAllColorsLabel: "Alle Farben anzeigen",
		ralSearchLabel: "RAL Farbe suchen",
		structureLabel: "Struktur",
		finishLabel: "Finish",
		powderSelectionHeading: "Pulverauswahl:",
		standardNoSurchargeSuffix: " (Standard ohne Aufpreis)",
		noPowderAvailable: "Keine Pulver mit aktuellem Filter verfügbar",
		nonStandardPowderInfo1: "Dieses Pulver ist nicht Teil des Standard-Sortiments und muss bestellt werden.",
		nonStandardPowderInfo2:
			"Ein einmaliger Aufpreis von {cost} wird angewandt. Bei mehreren Positionen in dieser Farbe, wird der Aufpreis nur einmal berechnet, indem er beim Auftragsrabatt berücksichtigt wird.",
		nonStandardPowderInfo3:
			"Bitte beachten Sie, dass dies auch eine Verlängerung der Lieferzeiten zur Folge haben kann.",
		faceLabel: "Fläche",
		baseCoatingLabel: "Vorgrundierung: Bietet Korrosionsschutz",
		warningText1:
			"Bei der Pulverbeschichtung muss mit einer {thickness} gerechnet werden. Konstruieren Sie allfällige Bohrungen und Ausschnitte entsprechend grösser. {gewinde} werden vor dem Beschichten abgedeckt und müssen nicht angepasst werden. {senkungen} werden nicht abgedeckt, jedoch wird die Schichtdicke bei der Fertigung kompensiert.",
		warningThicknessBold: "Schichtdicke von ca. 0.1mm",
		warningGewindeBold: "Gewinde",
		warningSenkungenBold: "Senkungen",
		warningTextOneSided:
			"Im Weiteren muss berücksichtigt werden, dass bei einseitiger Beschichtung die gegenüberliegende Seite nicht abgedeckt wird und somit mit einem {spray} auf dieser Seite gerechnet werden muss.",
		warningSprayBold: "Sprühnebel",
		warningText2:
			"{achtung} Die Pulverbeschichtung allein ist {noCorrosion}. Pulverbeschichtete {steelParts} sind deshalb {notOutdoor} geeignet, außer es wird eine {primer} vorgenommen. Dabei handelt es sich um eine zusätzliche Beschichtung, welche einen Korrosionsschutz für Stahlteile bietet. Pulverbeschichtete Teile aus Edelstahl oder Aluminium sind für Aussenanwendung oder Orte mit hoher Luftfeuchtigkeit geeignet, sofern keine extremen Umgebungsbedingungen herrschen. Bei extremen Witterungsbedingungen und in Umgebungen mit hoher Luftfeuchtigkeit und hohem Salzgehalt in der Luft sollte bei Aluminium ebenfalls eine Vorgrundierung gewählt werden. Bei Fragen und Unklarheiten können Sie sich gerne bei unserem Helpdesk melden.",
		warningAchtungBold: "Achtung:",
		warningNoCorrosionBold: "kein Korrosionsschutz",
		warningSteelPartsBold: "Stahlteile",
		warningNotOutdoorBold: "nicht für Aussenanwendung oder Orte mit hoher Luftfeuchtigkeit",
		warningPrimerBold: "Vorgrundierung",
		close: "Schliessen",
		removeTooltipSingle: "Entfernt die Pulverbeschichtung vom Artikel.",
		removeTooltipMultiple: "Entfernt die Pulverbeschichtung von allen Artikeln.",
		removeButton: "Entfernen",
		saveTooltipSingle: "Speichert die Pulverbeschichtung.",
		saveTooltipMultiple: "Speichert die Pulverbeschichtung für alle Artikel.",
		finishOptions: {
			all: "Alle",
			matt: "Matt",
			glossy: "Glanz",
		},
		structureOptions: {
			all: "Alle",
			smooth: "Glatt",
			fine: "Fein",
			rough: "Grob",
		},
		faceOptions: {
			top: "Oberseite",
			bottom: "Unterseite",
			both: "Beidseitig",
		},
		messages: {
			loadPowdersError: "Pulver konnten nicht geladen werden.",
			loadMaterialIdsError: "Werkstoff-Ids konnten nicht geladen werden.",
			saveError: "Die Oberflächenbehandlung von Artikel {articleId} konnte nicht gespeichert werden.",
			saveSuccess: "Die Oberflächenbehandlung wurde gespeichert.",
			deleteError: "Die Oberflächenbehandlung von Artikel {articleId} konnte nicht gelöscht werden.",
			deleteSuccess: "Die Oberflächenbehandlung wurde gelöscht.",
		},
	},
	articleZincCoatingEditDialog: {
		analyzingTitle: "Verzinkung wird untersucht...",
		close: "Schliessen",
		titleSingle: "Verzinkung - Artikel '{name}' ({id})",
		titleMultiple: "Verzinkung - {count} Artikel",
		errorIntroSingle: "Eine Verzinkung ist für diesen Artikel aus folgendem Grund nicht möglich:",
		errorIntroMultiple: "Eine Verzinkung ist für die aufgelisteten Artikel nicht möglich:",
		hotDipLabel: "Feuerverzinken",
		thicknessLabel: "Schichtdicke: ",
		hotDipThicknessValue: "50-150µm",
		galvanizeThicknessValue: "5-20µm",
		moreInfo: "Mehr Information",
		hotDipInfoText:
			"Beim Feuerverzinken werden die Bauteile in ein Zinkbad mit einer Temperatur von etwa 450 °C getaucht. Durch diese hohe Temperatur entstehen in den Bauteilen Spannungen. Daher ist eine geeignete Konstruktion der zu verzinkenden Teile von großer Bedeutung. Bei geschlossenen Bauteilen (z. B. geweißte Boxen) müssen Öffnungen vorgesehen werden. Diese ermöglichen einerseits das Entweichen der sich beim Erhitzen ausdehnenden Luft und andererseits den Abfluss des überschüssigen Zinks beim Herausziehen aus der Schmelze. Außerdem sind dünne Bleche (Dicke < 4mm) für die Feuerverzinkung meistens nicht geeignet, da sie sich unter Hitzeeinwirkung stark verziehen können.",
		hotDipNotPossibleSingle: "Für dieses Material ist die Feuerverzinkung nicht verfügbar.",
		assemblyHint:
			"Baugruppen können nur verzink werden, wenn alle Subartikel diese Art der Verzinkung zulassen.",
		hotDipNotPossibleMultiple:
			"Für diese Zusammensetzung an Materialien ist die Feuerverzinkung nicht verfügbar. Versuchen Sie, die Artikel einzeln zu verzinken.",
		hotDipPowderCoatedConflict:
			"Die Kombination Feuerverzinkung und Pulverbeschichtung bietet Blexon zurzeit nicht an.",
		threadsNotHotDippable: "Artikel mit Gewinde oder Durchzügen können nicht Feuerverzinkt werden.",
		galvanizeLabel: "Galvanisch verzinken",
		galvanizeInfoText:
			"Im Gegensatz zur Feuerverzinkung werden die Bauteile beim galvanischen Verzinken nicht in ein Zinkschmelzbad, sondern in einen Zinkelektrolyten eingetaucht. Dabei fungieren ein Zinkelement als Anode und das zu beschichtende Stahlteil als Kathode. Bei diesem Verfahren entsteht weniger Wärme und ist deshalb für dünnere Bleche geeignet. Für dauerhafte Aussenanwendungen ist die Dicke der Zinkschicht aber oft zu dünn.",
		galvanizeNotPossibleSingle: "Für dieses Material ist die galvanische Verzinkung nicht verfügbar.",
		galvanizeNotPossibleMultiple:
			"Für diese Zusammensetzung an Materialien ist die galvanische Verzinkung nicht verfügbar. Versuchen Sie, die Artikel einzeln zu verzinken.",
		sendToHelpdesk: "An Helpdesk senden",
		removeTooltipSingle: "Entfernt die Verzinkung vom Artikel.",
		removeTooltipMultiple: "Entfernt die Verzinkung von allen Artikeln.",
		removeButton: "Entfernen",
		saveTooltipSingle: "Speichert die Verzinkung.",
		saveTooltipMultiple: "Speichert die Verzinkung für alle Artikel.",
		messages: {
			loadError: "Verzinkungsdaten konnten nicht geladen werden.",
			saveError: "Die Verzinkung von Artikel {articleId} konnte nicht gespeichert werden.",
			saveSuccess: "Die Verzinkung wurde gespeichert.",
		},
	},
	certificateHelperDialog: {
		title: "Zertifikat / Zeugnisse",
		text1:
			"Nach der Auslieferung der Teile können Sie ein Abnahmeprüfzeugnis 3.1 nach EN 10204:2004 in Ihrem Bestellarchiv herunterladen.",
		text2: "Das Zeugnis stammt vom Hersteller des Rohmaterials und beinhaltet keine Umstempelungsbescheinigung durch den Blechverarbeiter.",
		close: "Schliessen",
	},
	isPowdercoatingPossibleDialog: {
		analyzingTitle: "Pulverbeschichtung wird untersucht...",
		notPossibleTitle: "Pulverbeschichtung nicht wählbar",
		possibleTitle: "Pulverbeschichtung möglich",
		reasonIntroSingle: "Eine Pulverbeschichtung ist für diesen Artikel aus folgendem Grund nicht möglich:",
		reasonIntroMultiple: "Eine Pulverbeschichtung ist für die aufgelisteten Artikel nicht möglich:",
		sendToHelpdesk: "An Helpdesk senden",
		close: "Schliessen",
		messages: {
			determineError: "Es konnte nicht bestimmt werden, ob der Artikel pulverbeschichtet werden kann.",
		},
	},
	sendToHelpdeskDialog: {
		title: "Artikel an Blexon Helpdesk senden",
		text1:
			"Sie senden diesen Artikel an das Blexon Helpdesk. Wir werden die Ursache der Fehlermeldungen prüfen und, falls möglich, beheben. Gerne geben wir Ihnen auch Hinweise, wie Sie die Konstruktion ändern können, damit der Artikel herstellbar wird.",
		freeService: "Dieser Service ist kostenlos.",
		text2:
			"Sie werden per E-Mail informiert, sobald der Artikel bearbeitet wurde. Die Überprüfung erfolgt während der Geschäftszeiten in der Regel innert Stunden.",
		text3:
			"Bitte beachten Sie, dass der Artikel nach dem Senden nicht mehr verändert oder gelöscht werden kann, bis dieser von Blexon freigegeben wird.",
		emailLabel: "E-Mail für Benachrichtigungen bezüglich dieses Artikels",
		sendButton: "Senden",
		sendTooltip: "Sendet den Artikel zur Abklärung ans Helpdesk.",
		abortDialogTitle: "Artikel nicht senden",
		abortDialogText:
			"Wollen Sie die Aktion wirklich abbrechen? Der Artikel wird nicht an das Blexon Helpdesk weitergeleitet.",
		abortConfirmButton: "Nicht senden",
		abortConfirmTooltip: "Bricht die Aktion ab, ohne den Artikel ans Helpdesk zu senden.",
		messages: {
			sendSuccess: "Artikel wurde ans Helpdesk gesendet.",
			sendError: "Artikel konnte nicht ans Helpdesk gesendet werden. Bitte wenden Sie sich an info@blexon.com.",
		},
	},
	tooManyCalculatingDialog: {
		title: "Zu viele Berechnungen gleichzeitig",
		text1: "Sie können bis zu 10 Artikel gleichzeitig blexonisieren.",
		text2:
			"Die Berechnungen sind sehr zeit- und resourcenintensiv. Deshalb limitieren wir die Anzahl der gleichzeitigen Berechnungen um unsere Server zu schützen und die Leistung gleichmässig auf alle Kunden zu verteilen.",
		text3: "Bitte warten Sie, bis einige Berechnungen abgeschlossen sind. Vielen Dank für Ihr Verständnis.",
		close: "Schliessen",
	},
	speechBubbleFloat: {
		dontShowAgain: "Meldung nicht mehr anzeigen",
	},
};
